<template>
    <div ref="paragraph" class="paragraph">

        <div class="content-wrapper">

            <div v-if="content.imageLink.length > 0">

                <div class="p-inner" style="display: flex; justify-content: start; flex-direction: column;">
                    <img class="paragraph--img" :src="content.imageLink" alt="">
                    <span class="paragraph--img_subline media-subline">{{content.imageSubline}}</span>
                </div>
            </div>

            <div v-if="content.imageLink.length == 0 && content.videoLink.length == 0">
                <div class="labels" v-if="content.newDataset == 'TRUE' || data.snippetText.length > 0 || data.highlighted == 'TRUE'">
                    <div v-if="content.newDataset == 'TRUE'" class="new-dataset">
                        <IconNewData/>
                        <span>new data</span>
                    </div>
                    <div v-if="data.snippetText.length > 0" class="more-info">
                        <div class="more-info-shape"></div>
                        <span>more info</span>
                    </div>
                    <div v-if="data.highlighted == 'TRUE'" class="highlights">
                        <IconHighlights/>
                        <span>highlights</span>
                    </div>
                </div>

                <div class="p-inner" style="display: flex; justify-content: start; flex-direction: column;">
                    <h3 class="paragraph--headline">{{content.title}}</h3>
                    <p v-html="content.text" v-if="content.text[0] != '#'" class="paragraph--text"></p>
                    <span v-html="content.text.substring(1)" v-if="content.text[0] == '#'" class="media-subline"></span>
                </div>
            </div>

            <div style="width: 100%" v-if="content.videoLink.length > 0">
                <div class="paragraph--video-container paragraph--video-container-16x9">
                    <video width="100%" height="56%" controls>
                        <source :src="content.videoLink" type="video/mp4">
                    </video>
                </div>
                <p v-html="content.videoSubline" class="media-subline"></p>
            </div>
            
            <div v-if="content.audioLink.length > 0">
                <audio controls :src="content.audioLink" autoplay></audio>
                <p class="media-subline"> {{ content.audioSubline }} </p>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import IconHighlights from './IconHighlights.vue'
    import IconNewData from './IconNewData.vue'

    import { 
        select as d3Select,
    } from 'd3';

    export default {
        name: "Paragraph",
        components: {
            IconNewData,
            IconHighlights,
        },
        data() {
            return (
                {
                    newDataset: false
                }
            )
        },
        props: ['content', 'data'],
        computed: {
            ...mapState(['storyActive', 'paragraphActive']),
            snippets() {
                return this.data.stories[this.storyActive].paragraphs;
            },
        },
        watch: {
            paragraphActive() {
                if (this.paragraphActive == this.data.snippetId) {
                    d3Select(this.$refs.indicator).classed('active', true);
                } else if (this.paragraphActive != this.data.snippetId) {
                    d3Select(this.$refs.indicator).classed('active', false);
                }
            },

        },
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .p-inner {

        // @media screen and (max-width: 380px) {
        //     width: 240px;
        // }
    }

    .paragraph {
        transition: opacity $time-m ease-in-out;
        line-height: 150%;
        width: 280px;
        margin-top: 20px;
        margin-bottom: 20px;
        opacity: .2;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        &-wrapper {
            margin-left: 0px;
            // @media screen and (max-width: 380px) {
            //     margin-left: 40px;
            // }
        }

        // @media screen and (max-width: 380px) {
        //     width: 240px;
        // }

        .content-wrapper {
            width: 280px;

            @media screen and (max-width: 380px) {
                width: 280px;
                min-width: 280px;
            }

            @media screen and (max-width: 320px) {
                min-width: 270px;
                width: 270px;
            }
        }

        .indicator-wrapper {
            min-height: 75px;
        }

        .indicator {
            width: 1px;
            margin-right: 15px;
            height: 100%;
            border-radius: 100px;
            background: black;
            opacity: .5;
            transition: all $time-s ease-in-out;
        }

        .active {
            opacity: 1;
            height: 100%;
            transition: all $time-s ease-in-out;
        }

        .media-subline {
            font-family: 'IBM Plex Sans';
            opacity: 1;
            font-style: italic;
            // margin-top: 10px;
            margin-right: 15px;
            margin-top: 2px;
            margin-bottom: 1em;
            font-size: 13px;
            line-height: 160% !important;


            a {
                color: black;
                text-decoration: none;
                padding-bottom: 2px;
                border-bottom: 1px solid black;
                transition: all ease-in-out .25s;

                &:hover {
                    opacity: .5;
                    transition: all ease-in-out .25s;
                }
            }
        }

        &--headline {
            font-size: $font-size-m;
            margin-bottom: 0px;
            letter-spacing: .25px;
            min-width: 280px;
            line-height: 140%;
            margin-top: 0px;

            @media screen and (max-width: 380px) {
                min-width: 240px;
            }
        }

        &--text {
            margin-top: 5px;
            font-size: $font-size-m;
            margin-bottom: 15px;
            width: 280px;
            line-height: 160%;
            transition: border $time-m ease-in-out;

            @media screen and (max-width: 320px) {
                width: 270px;
            }

            a {
                color: black;
                text-decoration: none;
                padding-bottom: 2px;
                border-bottom: 1px solid black;
                transition: all ease-in-out .25s;

                &:hover {
                    opacity: .5;
                    transition: all ease-in-out .25s;
                }
            }

        }

        &--img {
            width: 280px;
            margin-bottom: 10px;

            @media screen and (max-width: 380px) {
                width: 260px;
            }
        }

        &--video {

            &-container {
                margin-bottom: 10px;


                &-16x9 {
                    padding-bottom: 56.25%;
                }

                position: relative;
                height: 0;
                overflow: hidden;
                
                video {
                    position: absolute;
                    top:0;
                    left: 0;
                    width: 100%;
                    height: 100%; 
                }
            }    
        }
    }

    .labels {
        font-style: italic;
        display: flex;
        flex-direction: row;
    }

    .new-dataset {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 10px;

        svg {
            transform: translateY(.5px)
        }
        span {
            font-size: 12px;
            margin-left: 7px;
        }
    }

    .highlights {
        margin-right: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        span {
            font-size: 12px;
            margin-left: 7px;
        }
    }

    .more-info {
        margin-right: 10px;
        display: flex;
        flex-direction: row;

        .more-info-shape {
            border-radius: 100px;
            width: 6px;
            height: 6px;
            background: black;
            transform: translateY(10px);
            margin-right: 7px;
        }

        span {
            font-size: 12px;
        }
    }
</style>


